<template>
  <crud-editor
    ref="editor"
    :is-edit="true"
    :definition="definition"
    :fetch-by-id="fetchById"
    :disabled="hasNoEditPermission"
    :save="saveData"
    :show-save-and-next-button="false"
    :return-to="returnTo"
    :item-type="entity"
    :page-loading="loading"
    :get-layout="layout"
  >
    <template slot="page-buttons">
      <base-button
        v-if="canUpdateOrderLineDeliveryDate"
        :loading="exporting"
        :icon-only="false"
        type="primary"
        :caption="$t('transportOrder.updateOrders')"
        @click="updateOrderLineDeliveryDate()"
      />
      <base-button
        v-if="hasBlackHolePermissions"
        :loading="exporting"
        :icon-only="false"
        type="primary"
        caption="XX"
        @click="exportShipments(true)"
      />
      <base-button
        :loading="exporting"
        :icon-only="false"
        type="primary"
        :caption="$t(`transportOrder.exportShipments`)"
        @click="exportShipments(false)"
      />
    </template>
  </crud-editor>
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { hasExecutePermissionForCode, hasEditPermissionForCode } from '@/utils/permission';
import { getEditLayoutDefinition } from './form.js';
import BaseButton from '@/components/crud/BaseButton';
export default {
  components: {
    CrudEditor,
    BaseButton
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getEditLayoutDefinition
    };
  },
  computed: {
    canUpdateOrderLineDeliveryDate() {
      const form = this.$store.getters['editor/flattenedForm'];
      return (
        form && form.exportedAt && hasEditPermissionForCode('OrderLineDeliveryDate', this.$store.getters.permissions)
      );
    },
    hasBlackHolePermissions() {
      return hasExecutePermissionForCode('ShipmentListToBlackHole', this.$store.getters.permissions);
    },
    hasNoEditPermission() {
      return !hasEditPermissionForCode(this.entity, this.$store.getters.permissions);
    },
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  },
  methods: {
    fetchById(id) {
      return this.$store
        .dispatch(this.entityStore + '/getItem', { selector: { id } })
        .then(item => this.createFormDataFromItem(this, item));
    },
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
